export const WORKSPACE_STATUS = {
  PENDING: 'PENDING',
  DEFERRED: 'DEFERRED',
  INITIALIZING: 'INITIALIZING',
  READY: 'READY',
  STOPPED: 'STOPPED',
  DELETED: 'DELETED'
};

export const EDITOR_MODE = {
  FULL: 'full',
  SIMPLE: 'simple'
};
